<template>
  <DefaultLayout>
    <template #buttons>
      <ApplicationCreateAction @created="reload" v-if="can('APPLICATION_MANAGE')" />
    </template>

    <ApplicationFilter :filters="filters">
      <h1 class="h5 mt-2">
        {{ i18n('Applications') }}
        <span class="small text-muted" v-if="!pagination?.total">({{ applications.length }})</span>
        <span class="small text-muted" v-else>({{ pagination?.total }})</span>
      </h1>
      <template #buttons>
        <ExportToExcelAction cssClass="btn btn-sm btn-outline-dark ms-1" />
      </template>
    </ApplicationFilter>

    <ApplicationList :pagination="pagination" :applications="applications" :loading="loading"
      :autoLazyLoad="!!pagination.nextPageURI" @deleted="reload" @updating="loading = true" @updated="reload"
      @next="nextPage" @goToPage="goToPage" />
  </DefaultLayout>
</template>

<script>
import paginatedViewMixin from "@/mixins/common/paginatedViewMixin.js";
import api from "@/api.js";
import { canAccessPage } from "@/routeAcl.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import ExportToExcelAction from "@/components/common/actions/ExportToExcelAction.vue";
import ApplicationCreateAction from "@/components/application/ApplicationCreateAction.vue";
import ApplicationFilter from "@/components/application/ApplicationFilter.vue";
import ApplicationList from "@/components/application/ApplicationList.vue";

export default {
  mixins: [paginatedViewMixin,],
  components: {
    DefaultLayout,
    ExportToExcelAction,
    ApplicationCreateAction,
    ApplicationFilter,
    ApplicationList,
  },
  data() {
    return {
      listPropertyName: 'applications',
      apiResource: `applications`,
      applications: [],
    }
  },
  mounted() {
    this.$root.setPageTitle(this.i18n('Applications'));
    api.auth().then((user) => {
      this.$root.loggedUser = user;

      if (!user.loggedIn) {
        return; // Layout non-anonymous will handler redirect
      }

      if (!canAccessPage(this.$route?.name, user, this.$root.features)) {
        this.$router.push({ name: 'Index', });
        return;
      }

      this.load();
    });
  },
  watch: {
    params: {
      handler() {
        this.pagination.loadPages = 1;
        this.reload();
      },
      deep: true,
    },
  },
  methods: {
    extendApiParams(params) {
      params.acl = 'application';
    },
  },
};
</script>